export default "__VITE_ASSET__UZN85Y_h__"